module.exports = "https://static.zego.com/_next/static/images/CarFullMobile-c1d616590a2ae79a3441391843026f64.jpg";